<template>
  <div class="nav-header" style="cursor: auto">
    <!-- was `ui-sref="router-resources"`; ui-router directives cannot live in a Vue template, so
         the navigation is emitted and ProfileCtrl does the $state.go. -->
    <a id="homeLink" href="/" v-on:click.prevent="$emit('home')">
      <img class="img-fluid mx-auto d-block" alt="Hourglass" :src="logo" width="90px" />
    </a>
    <div class="profile-element m-t-xl">
      <div class="row v-center">
        <div class="col-3">
          <img id="avatar-img" class="rounded-circle" width="40px" height="40px" :src="avatar" />
        </div>
        <div class="col-9">
          <p class="white text-m" id="loggedInUser">{{ user.name }}</p>
        </div>
      </div>
      <div class="m-l-xs">
        <strong class="text-xs block white m-t" id="jobTitleLink"
          >{{ user.profile }}
          <button
            class="btn btn-info btn-circle btn-outline float-right"
            type="button"
            title="Edit Your Profile"
            v-on:click="$emit('edit')"
          >
            <i class="fa fa-pencil"></i>
          </button>
        </strong>
        <span class="text-xs block role-badges" v-if="badges.length">
          <span class="role-badge" v-for="badge in badges" :key="badge" :id="'role-' + badge.toLowerCase()">{{
            badge
          }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
// webpack rewrites these; a `require()` inside a template expression would not be resolved.
import logo from '../../web/images/hourglass-profile-no-text.png'
import avatar from '../../web/images/avatar.gif'
import { roleBadges } from '../service/roleBadges.js'

export default {
  name: 'ProfileComponent',
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    // The signed-in user's `cognito:groups`, straight from the token. A list rather than a
    // boolean per role: the two booleans this replaced could only ever describe two of the seven.
    roles: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return { logo, avatar }
  },
  computed: {
    badges() {
      return roleBadges(this.roles)
    },
  },
}
</script>

<style scoped>
.role-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 2px;
}

/* Small, muted, and quiet enough that five of them do not shout. */
.role-badge {
  display: inline-block;
  padding: 1px 6px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 9px;
  font-size: 10px;
  line-height: 13px;
  letter-spacing: 0.3px;
  color: rgba(255, 255, 255, 0.82);
  text-transform: uppercase;
}
</style>
